export default __webpack_public_path__ + "static/media/ahri-bg-large.42844927.jpg";